import { useTranslation } from '@mint-lib/i18n';
import { Card, typographyVariants } from '@mint-lib/tw-components';
import { ProgressLinear } from '@mint-lib/tw-components/patterns';

import { useUploadState } from '../../queries/index.js';

export const UploadProgressCard = ({ dataFileId }: { dataFileId: string }) => {
  const { t } = useTranslation('@myn/import-hub');
  const { data: uploadState } = useUploadState(dataFileId);

  if (uploadState?.status !== 'uploading') {
    return null;
  }

  return (
    <Card
      className="w-[418px]"
      contentClassName="flex flex-col justify-center gap-2 p-3 h-[64px]"
    >
      <span className={typographyVariants({ variant: 'label01' })}>
        {t(
          '{{processedRows}} rows out of {{totalRows}} has already been uploaded',
          uploadState,
        )}
      </span>
      <ProgressLinear
        value={Math.floor(
          (uploadState.processedRows / uploadState.totalRows) * 100,
        )}
        withLabel
      />
    </Card>
  );
};
